import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            为什么选择51吃瓜网
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            四大核心优势，为你打造最好的吃瓜体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuresData.map((feature, i) => {
            const iconBgs = [
              'bg-accent-100 text-accent-600',
              'bg-primary-100 text-primary-600',
              'bg-secondary-100 text-secondary-700',
              'bg-accent-100 text-accent-600',
            ];
            return (
              <div
                key={feature.id}
                className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 text-center hover:border-primary-200/60 transition-all cursor-pointer"
              >
                <div className={`w-12 h-12 mx-auto flex items-center justify-center rounded-xl ${iconBgs[i % 4]} mb-4`}>
                  <i className={`${feature.icon} text-xl`}></i>
                </div>
                <h3 className="font-medium text-foreground-900 text-sm md:text-base mb-2">
                  {feature.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}